import React from 'react';
import moment from 'moment';

const NeedsByDateCalContainer = (props: any) => {
  const { className, task, children } = props;
  return (
    <div className={className}>
      <div className={className}>{children}</div>
      <div
        style={{
          backgroundColor: '#5ba389',
          color: 'white',
          fontSize: '1.6em',
          fontWeight: 500,
        }}
      >
        <div
          style={{
            marginLeft: '30px',
            padding: '15px',
          }}
        >
          Needs by date is: {moment(task.due_date).utc().format('MM-DD-YYYY')}
        </div>
      </div>
    </div>
  );
};

export default NeedsByDateCalContainer;
